import script from "./AiTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiTabs.vue?vue&type=script&setup=true&lang=ts"

import "./AiTabs.scss?vue&type=style&index=0&id=1fdeddfe&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdeddfe"]])

export default __exports__